import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'

import PricingCard from 'components/PricingCard'

import {
  PricingListContainer,
  PricingListGrid,
  PricingListTabs,
  PricingListTab,
  PricingListTabDiscount,
  PricingListCustom,
  PricingListCustomLink,
} from './PricingList.styled'

const PricingList = () => {
  const history = useHistory()

  const [activeTab, setActiveTab] = useState<string>('monthly')
  const [isHover, setIsHover] = useState<boolean>(false)

  const toggleTab = (tab: string) => {
    if (activeTab !== tab) {
      setActiveTab(tab)
    }
  }

  const toogleHoverTabs = (tab: string) => {
    if (activeTab !== tab) {
      setIsHover(!isHover)
    }
  }

  const changePageToContact = () => {
    history.push('/contact')
  }

  return (
    <PricingListContainer>
      <PricingListTabs isHover={isHover}>
        <PricingListTab
          active={activeTab === 'annual'}
          onMouseEnter={() => toogleHoverTabs('annual')}
          onMouseLeave={() => toogleHoverTabs('annual')}
          onClick={() => toggleTab('annual')}>
          Annual <PricingListTabDiscount>(20% off)</PricingListTabDiscount>
        </PricingListTab>
        <PricingListTab
          active={activeTab === 'monthly'}
          onMouseEnter={() => toogleHoverTabs('monthly')}
          onMouseLeave={() => toogleHoverTabs('monthly')}
          onClick={() => toggleTab('monthly')}>
          Monthly
        </PricingListTab>
      </PricingListTabs>
      {activeTab === 'annual' ? (
        <PricingListGrid>
          <PricingCard
            name="Starter"
            price="1,530"
            period="year"
            features={[
              'Inbound Reservation',
              'Program Management',
              'Basic Client Management',
            ]}
          />
          <PricingCard
            name="Master"
            price="2,040"
            period="year"
            recomended
            importanText={1}
            features={[
              'Starter features, plus',
              '5 additional accounts',
              'Custom traction reports',
              'Email Reminders',
              'Waiver management',
              'Point of Sale',
            ]}
          />
          <PricingCard
            name="Pro"
            price="2,550"
            period="year"
            importanText={1}
            features={[
              'Master features, plus:',
              'Unlimited additional accounts',
              'Enhanced client management',
              'Custom email reminders',
              'Text message reminders',
              'Up to 10,000 custom marketing emails every month*',
              'Up to 5,000 custom marketing texts every month*',
              'Quickbooks integrations',
            ]}
          />
        </PricingListGrid>
      ) : (
        <PricingListGrid>
          <PricingCard
            name="Starter"
            price="150"
            period="month"
            features={[
              'Inbound Reservation',
              'Program Management',
              'Basic Client Management',
            ]}
          />
          <PricingCard
            name="Master"
            price="200"
            period="month"
            recomended
            importanText={1}
            features={[
              'Starter features, plus',
              '5 additional accounts',
              'Custom traction reports',
              'Email Reminders',
              'Waiver management',
              'Point of Sale',
            ]}
          />
          <PricingCard
            name="Pro"
            price="250"
            period="month"
            importanText={1}
            features={[
              'Master features, plus:',
              'Unlimited additional accounts',
              'Enhanced client management',
              'Custom email reminders',
              'Text message reminders',
              'Up to 10,000 custom marketing emails every month*',
              'Up to 5,000 custom marketing texts every month*',
              'Quickbooks integrations',
            ]}
          />
        </PricingListGrid>
      )}
      <PricingListCustom>
        Not finding one that’s right for you?{' '}
        <PricingListCustomLink onClick={changePageToContact}>
          Contact us
        </PricingListCustomLink>{' '}
        and we’ll help you only pay for the features you want. <br />
        <span>*</span> Larger plans are available for facilities exceeding these
        caps. Please{' '}
        <PricingListCustomLink onClick={changePageToContact}>
          contact us
        </PricingListCustomLink>{' '}
        for more details.
      </PricingListCustom>
    </PricingListContainer>
  )
}

export default PricingList
